import * as React from 'react'

import { applyFiltersForUsers } from 'modules/core/lib/filters'
import FiltersForm from 'modules/core/lib/forms/Filters'
import type User from 'modules/core/store/models/User'

import { useAsyncData } from './useAsyncData'

export default function useFilters(
  users: User[],
  options: Record<string, string> = {
    filterBy: 'activity___active',
  }
) {
  const filtersForm = React.useRef(new FiltersForm(options)).current

  const { loading, value: filteredUsers } = useAsyncData(
    () => applyFiltersForUsers(filtersForm, users, filtersForm.get('filterBy').value),
    [users.length, filtersForm.get('filterBy').value]
  )

  return {
    loading,
    filtersForm,
    users: filteredUsers ?? [],
  }
}
